import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { AppHelper } from '../../helpers/AppHelper';

export class TagsDisplay extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'TagsDisplay'
    this.pageTitle = Helper.getString('tags')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['devicetags'], queryParams: { groupId: this.orgId, pb: 'fieldDef' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => current.title,
      Type: (current) => {
        return (
          <div>
            {UiHelper.chipLive(current.state)}
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.orgId
    }
    this.addNewLabel = 'Create Tag'
    this.noTableHead = true
    this.allowAccessToRoles = ['VENUES']
    if (!UiHelper.isUserHasRoles(this.allowAccessToRoles)) this.noAdd = true
  }

  onFetchSuccess(results) {
    this.formDefinition = this.fieldDef = results[0].fieldDef
    // const stateField = this.formDefinition.steps[0].fields.find(i => i.key === 'state')
    // stateField.options = stateField.options.filter(i => ['LIVE', 'DISABLED'].includes(i.key))
    this.setState({
      items: results[0].items
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['devicetags']),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['devicetags', current.id]),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['devicetags', current.id]),
    });
  }


  onActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonDelete(this, current), this.allowAccessToRoles)
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/TagsDisplay.js